// ─────────────────────────────────────────────────────────────────────────────
// firebase/constants.ts – Shared application constants
// ─────────────────────────────────────────────────────────────────────────────

// Die Auftragsliste hat KEINE feste Obergrenze mehr (REQ-OPS-033, T-M9.3):
// `MAX_JOBS_LIMIT = 200` ist ersatzlos entfallen. An seine Stelle tritt die
// SEITENgroesse `JOBS_PAGE_SIZE` in `@/utils/jobPagination` — sie kuerzt nicht,
// sondern bestimmt, wie viel je Schritt nachgeladen wird.

/**
 * Maximum number of companies loaded at once.
 *
 * ⚠ OHNE VERWENDER SEIT DEM 2026-08-22 (T-M24.3, REQ-OPS-058) — berichtigt
 * statt geloescht (REQ-OPS-036 Praez. 6). Die Firmen-Auswahl blaettert nicht
 * mehr und traegt kein `limit`: der Auftraggeber hat am 2026-08-19
 * entschieden, dass jederzeit ALLE Firmen zur Auswahl bereitstehen. Die
 * Konstante steht als datierter Merkposten hier; dass sie in `dashboard/src`
 * NICHT mehr benutzt wird, haelt `test/listTruncation.test.ts` maschinell.
 * **Wer sie wieder in eine Abfrage schreibt, kehrt einen
 * Auftraggeber-Entscheid um und faellt dort auf.**
 */
export const COMPANY_LIST_LIMIT = 100;

/** Maximum number of printers loaded at once. */
export const PRINTER_LIST_LIMIT = 100;
